import { handleActions } from 'redux-actions';

const defaultOrderItemData = {
	0: {
		id: 0,
		name: '寵物入住',
		content: '寵物入住',
		price: 1500,
		type: 'MONTHLY',
	},
	1: {
		id: 1,
		name: '第二人入住',
		content: '第二人入住',
		price: 1500,
		type: 'MONTHLY',
	},

	2: {
		id: 2,
		name: '床包組租借',
		content: '床包組租借',
		price: 1500,
		type: 'SINGLE',
	},
};

export const defaultOrderData = {
	id: 1,
	userId: 93,
	roomId: 1,
	eventId: null,
	status: 'REVIEW',
	name: '',
	rentMonth: 3,
	dateFrom: '2018-09-14 00:00:00',
	dateTo: '2018-12-14 00:00:00',
	monthlyRent: 14639,
	initialPayment: 23562,
	roomMonthlyRent: 0,
	deposit: 0,
	energyPrice: 1939,
	administrativeFee: 1500,
	cleaningFee: 2500,
	serviceFee: 0,
	continue: 'WAIT',
	lastRenewableDate: '2018-10-29',
	certificateType: 'IDENTITY',
	certificateFile: '20180910-8d674c1e689541ae8b5f1153a5b58c7b.png',
	certificateNumber: '',
	extraCertificateNumber: null,
	extraCertificateFile: null,
	extraCertificateType: null,
	emergencyContact: 'Test2222',
	emergencyContactRelationship: '',
	emergencyContactMobile: '0912 345 678',
	emergencyContactMobileCountryCode: '',
	remark: '',
	createdAt: '2018-09-10 18:45:43',
	updatedAt: '2018-09-10 18:45:43',
	certificateFileUrl:
		'https://9floorco-living.25demo.com/backend/web/order/20180910-8d674c1e689541ae8b5f1153a5b58c7b.png',
	extraCertificateFileUrl: 'https://9floorco-living.25demo.com/backend/web/order/',
	renewButton: false,
	user: {},
	room: {
		id: 1,
		apartment_id: 1,
		name: 'Lois Wintheiser PhD',
		name_en: null,
		number: '產品編號_J76qg',
		type: 'CO_LIVING',
		status: 'AVAILABLE',
		living_status: 0,
		publish_status: 'DRAFT',
		price: 9781,
		energy_price: 1939,
		service_fee: 0,
		deposit: 19562,
		ping_number: 18,
		can_order_start: '2018-07-24 11:33:44',
		can_order_end: null,
		sex_limit: 'FEMALE',
		max_order: 200,
		double: 1,
		highlight: 0,
		release_time: '2018-09-04',
		order_expire_date: null,
		pet: 1,
		created_at: '2018-07-24 19:33:44',
		updated_at: '2018-09-18 14:53:32',
		performance: '43.56%',
		can_reserve: true,
		has_processing_order: null,
		has_processing_event: [],
		apartment: {
			id: 1,
			name: '(zh-tw)Emerald Predovic',
			name_en: '(en)Emerald Predovic',
			publish_status: 'DELETE',
			content: '介紹_F6SY3',
			mrt_id: 100,
			content_en: null,
			clean_service: '清潔打掃_9vV4I',
			trash_service: '垃圾代收_oXeLi',
			room: 3,
			max_people: 6,
			kitchen: 1,
			balcony: 1,
			pet: 1,
			public_bath: 2,
			ping_number: 21,
			floor_location: '5',
			floor: 18,
			elevator: 0,
			district_id: 214,
			city_id: 13,
			address: '彰化縣員林市中正里三民街18號',
			address_en: null,
			mrt_walk_time: 7,
			door_password: '門鎖密碼_oxvkF',
			wifi_name: '名稱_wMUZJ',
			wifi_password: '密碼_oRIqb',
			tax_id: 'ID_TwgP2',
			electric_number: '電號_O8Sv5',
			water_number: '水號_OLhpu',
			gas_number: '瓦斯區號_lNvf2',
			network_number: '網路區號_2C:86:72:57:7D:99',
			latitude: 23.9589925,
			longitude: 120.574348,
			remarks: '其他備註_zuPe6',
			remarks_en: null,
			created_at: '2018-07-24 19:33:43',
			updated_at: '2018-09-04 21:01:58',
		},
		photos: [],
	},
	detail: [],
	events: [
		{
			id: 106,
			no: '1809136KdTaA',
			staff_id: 36,
			event_type: 'CHECKOUT',
			room_id: 1,
			user_id: 93,
			work_date: '2018-09-19 11:45:00',
			hangout_url: '',
			status: 'RESERVED',
			check: 'N',
			feedback: 0,
			note: null,
			created_at: '2018-09-13 17:34:01',
			updated_at: '2018-09-13 17:39:56',
			order_id: 501,
			cancelable: false,
			changeable: false,
		},
		{
			id: 108,
			no: '180917vrz7J2',
			staff_id: 36,
			event_type: 'CHECKIN',
			room_id: 1,
			user_id: 93,
			work_date: '2018-09-19 11:30:00',
			hangout_url: '',
			status: 'CANCEL',
			check: 'N',
			feedback: 0,
			note: '',
			created_at: '2018-09-17 16:48:25',
			updated_at: '2018-09-18 00:41:14',
			order_id: 501,
			cancelable: false,
			changeable: false,
		},
	],
	payments: [],
};

export const defaultBookingData = {
	dateFrom: { value: '', status: '', valid: false },
	rentMonth: { value: { range: [], yearRange: [] }, status: '', valid: false },
	orderItem: {
		value: [],
		data: defaultOrderItemData,
		options: [0, 1, 2],
		status: '',
		valid: false,
	},
	name: { value: '', status: '', valid: false },
	address: { value: '', status: '', valid: false },
	certificateType: { value: [], status: '', valid: false },
	certificate: { value: '', status: '', valid: false },
	extraCertificateType: { value: [], status: '', valid: false },
	extraCertificate: { value: '', status: '', valid: false },
	emergencyContact: { value: '', status: '', valid: false },
	emergencyContactMobile: {
		value: '',
		country: {
			areaCodes: null,
			dialCode: '886',
			iso2: 'tw',
			name: 'Taiwan (台灣)',
			priority: 0,
		},
		validate: false,
		valid: false,
		status: '',
	},
	emergencyContactRelationship: { value: '', status: '', valid: false },
	emergencyAddress: { value: '', status: '', valid: false },
	accept: { value: false, status: '', valid: false },
	acceptInsurance: { value: false, status: '', valid: false },
	certificateFile: {
		filename: '',
		file: null,
		status: '',
		valid: false,
	},

	extraCertificateFile: {
		filename: '',
		file: null,
		status: '',
		valid: false,
	},
};

export const defaultCreditData = {
	cardNumber: { value: '', status: '', valid: false },
	expireMonth: { value: '', status: '', valid: false },
	expireYear: { value: '', status: '', valid: false },
	cvc: { value: '', status: '', valid: false },
	name: { value: '', status: '', valid: false },
};

export default handleActions(
	{
		UPDATE_BOOKING_FIELD: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				[action.payload.key]: {
					...state[action.payload.type][action.payload.key],
					...action.payload.value,
				},
			},
		}),

		UPLOAD_CERTIFICATE_FILE: (state, action) => ({
			...state,

			form: {
				...state.form,

				[action.payload.key]: {
					filename: action.payload.filename,
					file: action.payload.file,
				},
			},
		}),

		CLEAR_CERTIFICATE_FILE: (state, action) => ({
			...state,

			form: {
				...state.form,

				[action.payload.key]: {
					filename: '',
					file: null,
				},
			},
		}),

		BOOKING_GO_TO_STEP: (state, action) => ({
			...state,

			step: action.payload.step,
		}),

		FETCH_ORDER_FULFILLED: (state, action) => ({
			...state,

			data: action.payload.data,
			current: action.payload.current,
			old: action.payload.old,
		}),

		FETCH_USER_OVERVIEW_FULFILLED: (state, action) => ({
			...state,
			current: action.payload.current,
			data: { ...state.data, ...action.payload.data },
			alertCheckMethod: action.payload.alertCheckMethod,
		}),

		FETCH_ORDER_BY_ID_FULFILLED: (state, action) => ({
			...state,

			data: {
				...state.data,
				[action.payload.data.id]: action.payload.data,
			},
		}),

		FETCH_ORDER_ITEM_BY_ROOM_ID_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,
				orderItem: {
					...state.form.orderItem,
					data: action.payload.data,
					options: action.payload.list,
				},
			},
		}),

		VALIDATE_ORDER_POLICY_DATA: (state, action) => ({
			...state,

			form: {
				...state.form,

				[action.payload.key]: {
					...state.form[action.payload.key],
					status: 'VALIDATED',
					valid: action.payload.valid,
				},
			},
		}),

		CLEAR_VALIDATE_ORDER_POLICY_DATA: state => ({
			...state,

			form: {
				...state.form,
				name: { ...state.form.name, status: 'VALIDATING', valid: false },
				certificateType: { ...state.form.certificateType, status: 'VALIDATING', valid: false },
				certificate: { ...state.form.certificate, status: 'VALIDATING', valid: false },
				extraCertificateType: {
					...state.form.extraCertificateType,
					status: 'VALIDATING',
					valid: false,
				},
				extraCertificate: { ...state.form.extraCertificate, status: 'VALIDATING', valid: false },
				emergencyContact: { ...state.form.emergencyContact, status: 'VALIDATING', valid: false },
				emergencyContactMobile: {
					...state.form.emergencyContactMobile,
					status: 'VALIDATING',
					valid: false,
				},
				emergencyContactRelationship: {
					...state.form.emergencyContactRelationship,
					status: 'VALIDATING',
					valid: false,
				},
				emergencyAddress: {
					...state.form.emergencyAddress,
					status: 'VALIDATING',
					valid: false,
				},
				certificateFile: {
					...state.form.certificateFile,
					status: 'VALIDATING',
					valid: false,
				},
				extraCertificateFile: {
					...state.form.extraCertificateFile,
					status: 'VALIDATING',
					valid: false,
				},
			},
		}),

		SET_ACCESS_BOOKING: state => ({
			...state,
			canAccess: true,
		}),

		SET_BOOKING_FORM_DATA: (state, action) => ({
			...state,

			form: {
				...state.form,

				address: {
					...state.form.address,
					...action.payload.address,
				},
				emergencyContact: {
					...state.form.emergencyContact,
					...action.payload.emergencyContact,
				},
				emergencyContactMobile: {
					...state.form.emergencyContactMobile,
					...action.payload.emergencyContactMobile,
				},
				emergencyContactRelationship: {
					...state.form.emergencyContactRelationship,
					...action.payload.emergencyContactRelationship,
				},
				emergencyAddress: {
					...state.form.emergencyAddress,
					...action.payload.emergencyAddress,
				},
			},
		}),

		VALIDATE_ORDER_CREDIT_DATA: (state, action) => ({
			...state,

			creditForm: {
				...state.creditForm,

				[action.payload.key]: {
					...state.creditForm[action.payload.key],
					status: 'VALIDATED',
					valid: action.payload.valid,
				},
			},
		}),

		CLEAR_VALIDATE_ORDER_CREDIT_DATA: state => ({
			...state,

			creditForm: {
				...state.creditForm,
				name: { ...state.creditForm.name, status: 'VALIDATING', valid: false },
				cardNumber: { ...state.creditForm.cardNumber, status: 'VALIDATING', valid: false },
				expireMonth: { ...state.creditForm.expireMonth, status: 'VALIDATING', valid: false },
				expireYear: { ...state.creditForm.expireYear, status: 'VALIDATING', valid: false },
				cvc: { ...state.creditForm.cvc, status: 'VALIDATING', valid: false },
			},
		}),
	},
	{
		form: defaultBookingData,

		data: {},
		current: [],
		old: [],

		step: 0,

		canAccess: false,

		alertCheckMethod: { orderId: -1, type: '' },

		creditForm: defaultCreditData,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/booking.js